"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityTileSize = exports.VisitMethodGroup = exports.SEARCH_API_VERSION = exports.TAB_TYPE = exports.BASE_TAB = exports.LOCATION_HEADER = exports.PatientRelationship = exports.VisitType = exports.CONTACT_TYPE = exports.ShowField = exports.ProviderStatus = exports.SummaryField = void 0;
var SummaryField;
(function (SummaryField) {
    SummaryField["SPECIALTY_V8"] = "specialties.specialty";
    SummaryField["SPECIALTY"] = "specialties.name";
})(SummaryField = exports.SummaryField || (exports.SummaryField = {}));
var ProviderStatus;
(function (ProviderStatus) {
    ProviderStatus["REFERRED"] = "referred";
    ProviderStatus["BOOKED"] = "booked";
})(ProviderStatus = exports.ProviderStatus || (exports.ProviderStatus = {}));
var ShowField;
(function (ShowField) {
    ShowField["AVAILABILITY"] = "availability";
    ShowField["IMAGE"] = "image";
    ShowField["NAME"] = "name";
    ShowField["SPECIALTY"] = "specialty";
})(ShowField = exports.ShowField || (exports.ShowField = {}));
exports.CONTACT_TYPE = {
    PHONE: 'phone',
    FAX: 'fax',
    PMC_PHONE: 'PMC Phone',
    PMC_FAX: 'PMC Fax'
};
var VisitType;
(function (VisitType) {
    VisitType["PHONE"] = "phone";
    VisitType["VIDEO"] = "video";
    VisitType["IN_PERSON"] = "in_person";
})(VisitType = exports.VisitType || (exports.VisitType = {}));
var PatientRelationship;
(function (PatientRelationship) {
    PatientRelationship["NEW"] = "new";
    PatientRelationship["ESTABLISHED"] = "established";
})(PatientRelationship = exports.PatientRelationship || (exports.PatientRelationship = {}));
exports.LOCATION_HEADER = {
    PHONE: 'phone',
    FAX: 'fax',
    DISTANCE: 'distance'
};
exports.BASE_TAB = {
    LOCATIONS: 'locations',
    NOTES: 'notes',
    INSURANCE: 'insurance',
    PRACTICE_GROUPS: 'practiceGroups',
    CLINICAL_KEYWORDS: 'clinicalKeywords',
    TRAINING: 'training',
    SCHEDULING_INSTRUCTIONS: 'schedulingInstructions',
    COMMUNICATION: 'communication',
    ROUTING: 'routing'
};
exports.TAB_TYPE = {
    NOTES: 'notes',
    TABLE: 'table'
};
exports.SEARCH_API_VERSION = {
    V9: 'v9',
    V8: 'v8'
};
var VisitMethodGroup;
(function (VisitMethodGroup) {
    VisitMethodGroup["InPerson"] = "in_person";
    VisitMethodGroup["Virtual"] = "virtual";
})(VisitMethodGroup = exports.VisitMethodGroup || (exports.VisitMethodGroup = {}));
var AvailabilityTileSize;
(function (AvailabilityTileSize) {
    AvailabilityTileSize["LARGE"] = "large";
    AvailabilityTileSize["SMALL"] = "small";
})(AvailabilityTileSize = exports.AvailabilityTileSize || (exports.AvailabilityTileSize = {}));
//# sourceMappingURL=types.js.map